import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.facility.add');
import { OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { FACILITY_TYPES } from '../@constants';

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-facility-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.facility.add/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectFacilityAddComponent implements OnInit, OnChanges {
    @Input() isOpen: boolean = false;
    @Input() projectId: string = '';
    @Input() drawings: any[] = [];
    @Output() onClose = new EventEmitter<void>();
    @Output() onCreated = new EventEmitter<void>();

    public data: any = { name: '', type: '', description: '', customType: '' };
    public drawingsList: any[] = [];
    public checklistsList: any[] = [];
    public isCreating: boolean = false;
    public facilityTypes = FACILITY_TYPES;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        this.initDrawingsList();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['drawings'] || changes['isOpen']) {
            this.initDrawingsList();
        }
        if (changes['isOpen'] && this.isOpen) {
            await this.loadChecklists();
        }
    }

    private initDrawingsList() {
        this.drawingsList = (this.drawings || []).map(d => ({ ...d, selected: false }));
    }

    private async loadChecklists() {
        const { code, data } = await wiz.call('get_published_checklists');
        if (code === 200) {
            this.checklistsList = (data || []).map((c: any) => ({ ...c, selected: false }));
        } else {
            this.checklistsList = [];
        }
        await this.service.render();
    }

    public close() {
        this.data = { name: '', type: '', description: '', customType: '' };
        this.drawingsList.forEach(d => d.selected = false);
        this.checklistsList.forEach(c => c.selected = false);
        this.onClose.emit();
    }

    public async toggleDrawing(drawing: any) {
        drawing.selected = !drawing.selected;
        await this.service.render();
    }

    public async toggleChecklist(checklist: any) {
        checklist.selected = !checklist.selected;
        await this.service.render();
    }

    public isPdf(drawing: any): boolean {
        const filepath = drawing?.filepath || drawing?.file_path || '';
        return filepath.toLowerCase().endsWith('.pdf');
    }

    public getFileName(drawing: any): string {
        return drawing?.filename || drawing?.filepath?.split('/').pop() || '제목 없음';
    }

    public formTypeLabel(type: string): string {
        const map: any = { generic: '일반', inspection: '정기안전점검' };
        return map[type] || type || '일반';
    }

    public async create() {
        if (!this.data.name.trim()) {
            await this.service.alert.show({
                title: '알림',
                message: '시설물명을 입력하세요.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            return;
        }

        if (this.data.type === 'custom' && !this.data.customType.trim()) {
            await this.service.alert.show({
                title: '알림',
                message: '시설물 유형을 입력하세요.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            return;
        }

        this.isCreating = true;
        await this.service.loading.show();

        const facilityType = this.data.type === 'custom' ? this.data.customType : this.data.type;
        const selectedDrawings = this.drawingsList.filter(d => d.selected).map(d => d.id);
        const selectedChecklists = this.checklistsList.filter(c => c.selected).map(c => c.id);
        const { code, data } = await wiz.call('create_facility', {
            project_id: this.projectId,
            name: this.data.name,
            type: facilityType,
            description: this.data.description,
            drawing_ids: JSON.stringify(selectedDrawings),
            checklist_ids: JSON.stringify(selectedChecklists)
        });

        await this.service.loading.hide();
        this.isCreating = false;

        if (code === 200) {
            this.onCreated.emit();
            this.close();
            await this.service.alert.show({
                title: '성공',
                message: '시설물이 등록되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
        } else {
            await this.service.alert.show({
                title: '오류',
                message: data || '시설물 추가에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }
        await this.service.render();
    }
}

export default ComponentProjectFacilityAddComponent;